import React from "react";
import i18n from "../../../i18n";
import set from "@rill/set";
import { withTranslation } from "react-i18next";
import SettingsNav from "../../../parts/settings-nav";
import ToolTip from "../../../parts/tooltip-portal";
import submit from "submit-form";
import BackArrowButton from "../../../parts/back-arrow-button";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { RillContext } from "../../../rill/RillReact/share/base";

class StorefrontScripts extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      global: "",
      paymentSuccess: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { activeUser, organizationOwner } = this.context.locals;
    const userToRequest = getUserToRequest(activeUser, organizationOwner);
    const { customBranding } = userToRequest;
    let initialState = {};

    if (customBranding && customBranding.storefrontSnippets) {
      const { global, paymentSuccess } = customBranding.storefrontSnippets;
      initialState = {
        global,
        paymentSuccess,
      };
    }

    this.setState(initialState);
  }

  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    });
  }

  renderPaymentTooltip() {
    const { t } = this.props;
    return (
      <ToolTip
        body={[
          <div className="paymentSucess-tooltip" key="tooltip">
            <p>{t("storefrontScripts.paymentTooltipIntro")}</p>
            <p>{t("storefrontScripts.paymentTooltipExample")}</p>
            <p>{`gtag("event", "conversion", {`}</p>
            <p>send_to: "AW-YYYYYY/XXXXX",</p>
            <p>
              unit_amount: <span style={{ color: "green" }}>%PRICE%</span>,{" "}
            </p>
            <p>
              interval: <span style={{ color: "green" }}>%INTERVAL%</span>,{" "}
            </p>
            <p>
              email: <span style={{ color: "green" }}>%EMAIL%</span>,
            </p>
            <p>{`});`}</p>
            <p>
              <span style={{ color: "green" }}>
                {t("storefrontScripts.greenPlaceholder")}
              </span>
            </p>
          </div>,
        ]}
      >
        <img className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  }

  renderGlobalTooltip() {
    const { t } = this.props;
    return (
      <ToolTip body={[t("storefrontScripts.globalTooltip")]}>
        <img className="help-icon" src="/img/svg/question-circle.svg" />
      </ToolTip>
    );
  }

  render() {
    const { t } = this.props;
    const { global, paymentSuccess } = this.state;
    // Team Coach can view org settings but not change them — the server
    // already rejects the POST, this just keeps the save button from
    // silently failing.
    const isReadOnly =
      this.context.locals.organizationRoleName === "Team Coach";
    const placeholders = {
      global: `
      <script src="https://yourcdn.script.com/script.js"></script>
      <script>scriptFunction(new Date());</script>`,
      paymentSuccess: ` 
      gtag("event", "conversion", {
        send_to: "AW-YYYYY/XXXXX",
        unit_amount: %PRICE%,
        interval: %INTERVAL%,
        email: %EMAIL%,
      });`,
    };
    return (
      <div className="Main Settings-Branding Settings-Integrations">
        <SettingsNav />

        <BackArrowButton
          classNames="only-show-mobile settings-back"
          text={t("storefrontScripts.title")}
          onBack={() =>
            submit(`/coaching-portal/settings/profile`, {
              method: "GET",
            })
          }
        />
        <div className="Content">
          <div className="frame alt">
            <form
              id="form-storefront"
              method="POST"
              encType="multipart/form-data"
              data-noreset
            >
              <div className="wrapper">
                <div className="inputs-right">
                  <div
                    className="label inline"
                    style={{
                      fontSize: 20,
                      marginBottom: 20,
                    }}
                  >
                    {t("storefrontScripts.storefrontIntegrations")}
                  </div>
                  <div className="inline info">
                    {t("storefrontScripts.storefrontIntegrationsIntro")}
                    <br />
                    <br />
                    {t("storefrontScripts.contactBeforeAdding")}
                  </div>
                  <div
                    className="label inline"
                    style={{
                      fontSize: 16,
                      marginBottom: 20,
                    }}
                  >
                    {t("storefrontScripts.snippets")}
                  </div>
                  <div className="inputs-row grow">
                    <div className="column">
                      <div className="label inline">
                        {t("storefrontScripts.globalSiteSnippet")}
                      </div>
                      {this.renderGlobalTooltip()}
                      <textarea
                        name="global"
                        className="textarea-input"
                        placeholder={placeholders.global}
                        value={global}
                        onChange={this.handleChange}
                        disabled={isReadOnly}
                      />
                    </div>
                  </div>
                  <div className="inputs-row grow">
                    <div className="column">
                      <div className="label inline">
                        {t("storefrontScripts.paymentSuccessSnippet")}
                      </div>
                      {this.renderPaymentTooltip()}
                      <textarea
                        name="paymentSuccess"
                        className="textarea-input"
                        placeholder={placeholders.paymentSuccess}
                        value={paymentSuccess}
                        onChange={this.handleChange}
                        disabled={isReadOnly}
                      />
                      <div className="inline info">
                        <p>
                          {t("storefrontScripts.placeholdersLabel")}{" "}
                          <p>{t("storefrontScripts.placeholderPrice")}</p>{" "}
                          <p>{t("storefrontScripts.placeholderInterval")}</p>{" "}
                          <p>{t("storefrontScripts.placeholderEmail")}</p>{" "}
                        </p>
                        <p>{t("storefrontScripts.placeholdersUsage")}</p>
                        <p className="warning-scripts-storefront">
                          {t("storefrontScripts.scriptWarning")}
                        </p>
                      </div>
                    </div>
                  </div>
                  {isReadOnly && (
                    <p role="alert">{t("settingsNav.readOnlyTooltip")}</p>
                  )}
                  <div className="column button-column" data-col="1/1">
                    <button
                      className="button-input save"
                      type="submit"
                      disabled={isReadOnly}
                    >
                      {t("common:save")}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

StorefrontScripts.contextType = RillContext;

const StorefrontScriptsWithI18n = withTranslation(["dashboard", "common"])(
  StorefrontScripts
);

const StorefrontScriptsController = (app) => {
  app
    .get(
      "/storefront-scripts",
      set("heading", "Edit Storefront Scripts"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin", "Team Coach"]
        ),
      ({ res }) => (res.body = <StorefrontScriptsWithI18n />)
    )
    .post(
      "/storefront-scripts",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body } = req;
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { customBranding = {} } = userToRequest;
        const newBody = {};

        if (
          customBranding &&
          customBranding.storefrontSnippets &&
          customBranding.storefrontSnippets.active
        ) {
          body.active = true;
        } else {
          assert(
            false,
            400,
            "Ask for permissions in order to update the scripts"
          );
        }
        newBody.customBranding = Object.assign({}, customBranding);
        newBody.customBranding.storefrontSnippets = body;
        try {
          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", i18n.t("auth:user.updatedSuccess"));
        } catch (e) {
          flash("error", e.message);
        }

        res.redirect("/coaching-portal/settings/storefront-scripts");
      }
    );
};

export default StorefrontScriptsController;
